import React, { FC, useState } from "react";
import classes from "./OfferDocuments.module.css";
import {
  UploadOutlined,
  DownloadOutlined,
  PaperClipOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import { useGetApplicationDataToBankQuery } from "../../../../../store/api/applicationBankApi/applicationBank.api";
import { useParams } from "react-router-dom";
import { Button, Flex, message, Spin, Upload } from "antd";

import { UploadRequestOption } from "rc-upload/lib/interface";
import { validateFile } from "../../../../../utils/utilities/validateFile";
import { Guard } from "../../../../../utils/guards/Guard";
import { APPLICATION_BANK_STATUS } from "../../../../../utils/guards/ApplicationBankStatusGuard/types";
import { applicationBankDocumentsApi } from "../../../../../services/documents/documents.api";
import { useUploadOfferDocumentMutation } from "../../../../../store/api/applicationBankApi/offer.api";

const { downloadDocument, downloadOfferDocuments } =
  applicationBankDocumentsApi;

export const OfferDocuments: FC = () => {
  const { applicationBankId } = useParams();
  const { data: applicationBank } = useGetApplicationDataToBankQuery(
    Number(applicationBankId)
  );
  const [uploadDocument, { isLoading, originalArgs }] =
    useUploadOfferDocumentMutation();
  const isUploading = (typeDocId: number) => {
    return isLoading && typeDocId === originalArgs?.typeDocId;
  };
  const offerDocuments = applicationBank?.offer;

  const [isDownloadingAllDocuments, setIsDownloadingAllDocuments] =
    useState(false);

  const handleUploadDocument = (
    options: UploadRequestOption,
    typeDocId: number
  ) => {
    const { file } = options;
    const { isValidate, error } = validateFile(file as File);

    if (isValidate) {
      uploadDocument({
        file: file as File,
        applicationBankId: Number(applicationBankId),
        typeDocId: typeDocId,
      });
    } else {
      message.error(error);
    }
  };

  const handleDownloadDocument = ({
    applicationBankId,
    fileId,
    fileName,
  }: {
    applicationBankId: number;
    fileId: number;
    fileName: string;
  }) => {
    downloadDocument({
      applicationBankId,
      fileId,
      fileName,
    });
  };

  const handleDownloadAllDocuments = async () => {
    setIsDownloadingAllDocuments(true);
    await downloadOfferDocuments({
      organizationINN: applicationBank?.application.organization.inn || "",
      organizationName: applicationBank?.application.organization.name || "",
      applicationBankId: Number(applicationBankId),
    });
    setIsDownloadingAllDocuments(false);
  };

  return (
    <>
      {offerDocuments?.map((documentGroup) => {
        return (
          <div key={documentGroup.id} className={classes.cardWrapper}>
            <div className={classes.cardHeader}>
              <div className={classes.cardTitle}>{documentGroup.name}</div>
              <Upload
                className={classes.uploadButtonWrapper}
                showUploadList={false}
                customRequest={(options) =>
                  handleUploadDocument(options, documentGroup.id)
                }
              >
                {!!applicationBank?.modified_bank_status.type &&
                  documentGroup.type !== "ANKETA" && (
                    <Guard.ApplicationBankStatus
                      status={applicationBank?.modified_bank_status.type}
                      allowedStatuses={[
                        APPLICATION_BANK_STATUS.DIRECTED,
                        APPLICATION_BANK_STATUS.REVISION,
                        APPLICATION_BANK_STATUS.OFFER,
                        APPLICATION_BANK_STATUS.AGREED,
                      ]}
                    >
                      <Button className={classes.uploadButton}>
                        {isUploading(documentGroup.id) ? (
                          <Spin
                            indicator={<LoadingOutlined spin />}
                            size="small"
                          />
                        ) : (
                          <UploadOutlined />
                        )}
                        Загрузить
                      </Button>
                    </Guard.ApplicationBankStatus>
                  )}
              </Upload>
            </div>

            <div className={classes.documentList}>
              {Array.isArray(documentGroup.document) &&
                documentGroup.document?.map((document) => {
                  return (
                    <div
                      key={document.id}
                      className={classes.documentRow}
                      onClick={() =>
                        handleDownloadDocument({
                          applicationBankId: Number(applicationBankId),
                          fileId: document.id,
                          fileName: document.name,
                        })
                      }
                    >
                      <PaperClipOutlined className={classes.fileIcon} />
                      <span
                        className={
                          document.deleted_at
                            ? classes.uploadedFileName
                            : classes.uploadedFileNameActive
                        }
                      >
                        {document.name}
                      </span>
                      <DownloadOutlined className={classes.downloadButton} />
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
      <Flex justify="flex-end" style={{ marginTop: "15px" }}>
        <Button
          type="primary"
          onClick={handleDownloadAllDocuments}
          loading={isDownloadingAllDocuments}
        >
          Скачать все документы
        </Button>
      </Flex>
    </>
  );
};
